import React, { useRef, useEffect, useState } from 'react'
import moment from 'moment'
import { useSelector, useDispatch } from 'react-redux'

import Container from './styles'
import {
  Button,
  ButtonsContainer,
  OnboardTitle,
  OnboardSubtitle,
  ContactInput,
  CountdownTimer,
} from '@valid/components'

import {
  phoneFormat,
  validationMessages,
  phoneValidator,
} from '@valid/config'
import * as Yup from 'yup'
import { post, get } from 'service/api'
import { useParams } from "react-router";

export default function ({ location, history }) {
  const { token } = useSelector((state) => state.token)
  const { requestId } = useParams()

  const dispatch = useDispatch()
  const [phone, setPhone] = useState(null)
  const [sendEnabled, setSendEnabled] = useState(false)
  const [showTimer, setShowTimer] = useState(true)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  // const { loading, error } = {loading: false, error: "Errou"}
  const { state } = location
  const firstRef = useRef()
  const secondRef = useRef()
  const thirdRef = useRef()
  const fourthRef = useRef()

  const refsArray = [firstRef, secondRef, thirdRef, fourthRef]

  useEffect(() => {
    firstRef.current.focus()
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)

      const res = await get({
        url: `/request/${requestId}/sms`,
        token,
      })

      const { phone } = res.data
      setPhone(phone)
      setLoading(false)
    }

    fetchData()
  }, [requestId])

  function clearCode() {
    refsArray.map((item) => {
      item.current.value = ''
    })
    firstRef.current.focus()
  }
  function checkCode() {
    return refsArray.reduce((acc, value) => acc + '' + value.current.value, '')
  }

  const handleSubmit = async () => {
    setLoading(true)

    const code = checkCode()

    const res = await post({
      url: `/request/${requestId}/sms/verify`,
      token,
      data: {
        token: code,
      }
    })

    setLoading(false)

    if (res.status === 200) {
      history.replace({
        pathname: '/success',
        state: {
          message: "Token validado com sucesso!",
          redirect: "/dashboard"
        }
      })
    }

    if (res.status === 400) {
      const errorCode = res.data.error
      const errorMessage = res.data.message
      clearCode()

      if (errorCode === 'MAX_ATTEMPTS') {
        history.replace({
          pathname: `/service/selection/${requestId}`,
          state: {
            error: errorMessage
          }
        })
      }
      setError(errorMessage)
    }
  }

  const autoTab = (index) => {
    if (refsArray[index].current.value) {
      if (index < refsArray.length - 1) {
        refsArray[index + 1].current.focus()
      }
    } else {
      if (index > 0) {
        refsArray[index - 1].current.focus()
      }
    }

    const code = checkCode()
    if (code.length === 4) setSendEnabled(true)
    else setSendEnabled(false)
  }

  const handleTimerEnded = () => {
    setShowTimer(false)
  }

  const handleResendSms = async () => {
    setLoading(true)

    await get({
      url: `/request/${requestId}/sms/resend`,
      token,
    })

    setLoading(false)
    setShowTimer(true)
  }

  async function returnSubmit() {
    setLoading(true)

    history.push({
      pathname: `/service/selection/${requestId}`,
      state: {
        requestId: requestId
      }
    })
  }

  const validationSchema = Yup.object({
    phone: Yup
      .string()
      .required(validationMessages.required)
      .transform((value, originalValue) => {
        return value ? value.trim() : value
      })
      .test('valid', validationMessages.invalidPhone, (val) => {
        if (val) return phoneValidator(val)
        return false
      })
  })

  const formatPhone = (number) => {
    if (number) return `(${number.substring(0, 2)}) ${number.substring(2, 6)}-${number.substring(6, number.length)}`;
  }
  return (
    <Container
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.4 }}
    >
      <OnboardTitle>Confirme o celular</OnboardTitle>
      <OnboardSubtitle>Insira o código de 4 digitos enviado</OnboardSubtitle>
      <ContactInput
        value={phone}
        loading={loading}
        label="phone"
        applyFilter={formatPhone}
      />

      <div className="codeContainer">
        {refsArray.map((item, i) => (
          <input
            key={i}
            inputMode="numeric"
            pattern="[0-9]*"
            ref={item}
            maxLength="1"
            onKeyUp={() => autoTab(i)}
          />
        ))}
      </div>

      <small className="hint">
        O recebimento do SMS pode levar até 3 minutos
      </small>

      {showTimer && (
        <div className="resend_sms">
          O reenvio do SMS será possível em
          <CountdownTimer
            time={moment().add(3, 'm')}
            callback={handleTimerEnded}
          />
        </div>
      )}
      {!showTimer && (
        <ButtonsContainer>
          <Button
            onClick={handleResendSms}
            loading={loading}
            variant="primary"
          >
            Reenviar SMS
          </Button>
        </ButtonsContainer>
      )}

      {error && <div className="form__error">{error}</div>}

      <ButtonsContainer>
        <Button
          onClick={sendEnabled ? () => handleSubmit() : null}
          loading={loading}
          variant={sendEnabled ? 'primary' : ''}
        >
          Confirmar código
        </Button>
        <Button
          onClick={returnSubmit}
          variant='primary'
        >
          Voltar
        </Button>
      </ButtonsContainer>
    </Container>
  )
}
